import template from './imageFormElement.html';
import controller from './imageFormElement.controller';
import './imageFormElement.scss';

let imageFormElementComponent = {
  restrict: 'E',
  bindings: {
    label: '@',
    tip: '@',
    name: '@',
    storeFile: '&',
    removeFile: '&',
    thumb: '<',
    type: '@',
    validationError: '<'
  },
  template,
  controller
};

export default imageFormElementComponent;
